<template>
  <div class="info-view">
    <div style="text-align: left;"><md-button v-if="parent && !parent.data.inDialog" @click="back();">Back</md-button></div>
    <viewer
      :content="true"
      :embed="true"
      :mode="mode"
      :nid="nid"
      :sid="null"
      :elements="saveData.value"
    />
  </div>
</template>

<script>
import FbElementMixin from "../FbElementMixin";

export default {
  name: "FbInfoView",
  props: ["nid", "element", "mode", "validate", "step", "active"],
  mixins: [FbElementMixin],
  activated() {
    this.init();
  },
  created() {
    this.init();
  },
  data() {
    return {
      parent: null,
      tempData: {
        label: this.element && this.element.data ? this.element.data.label : "",
        value: this.element && this.element.data ? this.element.data.value : [],
        required: this.element && this.element.data ? this.element.data.required : false
      },
      saveData: {
        label: this.element && this.element.data ? this.element.data.label : "",
        value: this.element && this.element.data ? this.element.data.value : [],
        required: this.element && this.element.data ? this.element.data.required : false
      }
    };
  },
  methods: {
    back() {
      history.back();
    },
    init() {
      if (!this.nid) {
        return;
      }
      if (this.$route && this.$route.params && this.$route.params.component) {
      let components =
        window.drupalSettings.form_builder[this.nid].tabs[this.$route.name]
          .data;
      let findComponent = components => {
        for (let key in components) {
          if (components[key].uuid == this.$route.params.component) {
            return components[key];
          }
          if (components[key].list.length) {
            let element = findComponent(components[key].list);
            if (element) {
              return element;
            }
          }
        }
      };
      let element = findComponent(components);
      if (element) {
        this.parent = element;
        this.saveData = element.data;
      }
    }
    }
  },
  watch: {
    nid: function nid() {
      this.init();
    },
  }
};
</script>


<style scoped>
.md-dialog {
  min-width: 60%;
}
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
